(function() {
  // ============ CONFIGURATION ============
  var QUALIFYING_TAG = 'SkoolTrialAluminum';
  var QUALIFYING_MINIMUM_CENTS = 30000; // $300.00

  // Variant ID of the free gift (TBN Core Membership)
  var GIFT_VARIANT_ID = 44180186202247;

  // Section IDs your theme uses for the cart UI. Extra IDs are harmless —
  // Shopify just ignores ones that don't exist.
  var CART_SECTION_IDS = [
    'cart-drawer',
    'cart-notification',
    'cart-icon-bubble',
    'cart-live-region-text',
    'main-cart-items',
    'main-cart-footer'
  ];
  // ========================================

  var CART_API = '/cart.js';
  var ADD_API = '/cart/add.js';
  var CHANGE_API = '/cart/change.js';

  var syncing = false;
  var resyncPending = false;
  var tagCache = {}; // handle -> boolean

  function getCart() {
    return fetch(CART_API, { credentials: 'same-origin' }).then(function(res) {
      return res.json();
    });
  }

  function addGift() {
    return fetch(ADD_API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
        sections: CART_SECTION_IDS.join(',')
      })
    }).then(function(r) { return r.json(); });
  }

  function removeGift(lineIndex) {
    return fetch(CHANGE_API, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0,
        sections: CART_SECTION_IDS.join(',')
      })
    }).then(function(r) { return r.json(); });
  }

  // Checks the product's tags by fetching /products/{handle}.js (cached)
  function productHasQualifyingTag(handle) {
    if (!handle) return Promise.resolve(false);
    if (Object.prototype.hasOwnProperty.call(tagCache, handle)) {
      return Promise.resolve(tagCache[handle]);
    }
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) return { tags: [] };
        return res.json();
      })
      .then(function(product) {
        var tags = [];
        if (Array.isArray(product.tags)) {
          tags = product.tags;
        } else if (typeof product.tags === 'string') {
          tags = product.tags.split(',').map(function(t) { return t.trim(); });
        }
        var has = tags.indexOf(QUALIFYING_TAG) !== -1;
        tagCache[handle] = has;
        return has;
      })
      .catch(function() {
        tagCache[handle] = false;
        return false;
      });
  }

  function cartQualifies(cart) {
    var items = cart.items.filter(function(item) {
      return item.variant_id !== GIFT_VARIANT_ID;
    });
    if (!items.length) return Promise.resolve(false);

    var checks = items.map(function(item) {
      return productHasQualifyingTag(item.handle).then(function(isTagged) {
        if (!isTagged) return 0;
        if (typeof item.final_line_price === 'number') return item.final_line_price;
        if (typeof item.line_price === 'number') return item.line_price;
        return (item.price || 0) * (item.quantity || 0);
      });
    });

    return Promise.all(checks).then(function(amounts) {
      var total = amounts.reduce(function(sum, n) { return sum + n; }, 0);
      return total >= QUALIFYING_MINIMUM_CENTS;
    });
  }

  function findGiftLineIndex(cart) {
    return cart.items.findIndex(function(item) {
      return item.variant_id === GIFT_VARIANT_ID;
    });
  }

  function syncGift(callback) {
    if (syncing) {
      // Don't drop the request — remember to re-run once the current sync finishes.
      resyncPending = true;
      if (callback) callback();
      return;
    }
    syncing = true;

    getCart().then(function(cart) {
      var giftIndex = findGiftLineIndex(cart);
      var hasGift = giftIndex !== -1;

      return cartQualifies(cart).then(function(qualifies) {
        if (qualifies && !hasGift) {
          return addGift().then(function(response) {
            applySectionUpdates(response && response.sections);
            reloadCartUI();
          });
        } else if (!qualifies && hasGift) {
          return removeGift(giftIndex + 1).then(function(response) {
            applySectionUpdates(response && response.sections);
            reloadCartUI();
          });
        }
      });
    }).catch(function(e) {
      console.error('[Free Gift]', e);
    }).finally(function() {
      syncing = false;
      if (callback) callback();
      if (resyncPending) {
        resyncPending = false;
        setTimeout(syncGift, 0);
      }
    });
  }

  // Replace live sections with the freshly rendered HTML Shopify returned.
  function applySectionUpdates(sections) {
    if (!sections) return;
    var parser = new DOMParser();

    Object.keys(sections).forEach(function(sectionId) {
      var html = sections[sectionId];
      if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');

      // Try a few common mount points used by Dawn, Impulse, Prestige, etc.
      var candidates = [
        '#shopify-section-' + sectionId,
        '#' + sectionId,
        '[id="' + sectionId + '"]',
        '[data-section-id="' + sectionId + '"]'
      ];

      for (var i = 0; i < candidates.length; i++) {
        var live = document.querySelector(candidates[i]);
        var fresh = doc.querySelector(candidates[i]) || doc.body.firstElementChild;
        if (live && fresh) {
          live.innerHTML = fresh.innerHTML;
          break;
        }
      }
    });
  }

  function reloadCartUI() {
    // Fire the events various themes listen for.
    ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change'].forEach(function(name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });

    // Dawn-style cart drawer: nudge its publisher if present.
    if (window.PUB_SUB_EVENTS && window.publish) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (e) {}
    }
  }

  // --- Intercept fetch to detect cart changes ---
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    // Intercept checkout fetches — sync gift before allowing through
    if (url.includes('/wallets/checkouts') || url.includes('/checkout')) {
      return new Promise(function(resolve) {
        syncGift(function() {
          resolve(originalFetch.apply(window, args));
        });
      });
    }

    var result = originalFetch.apply(this, args);

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      result.then(function() {
        if (!url.includes(String(GIFT_VARIANT_ID))) {
          setTimeout(syncGift, 300);
        }
      }).catch(function() { /* swallow — theme will show its own error */ });
    }
    return result;
  };

  // --- Intercept XMLHttpRequest for older themes ---
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return origXHROpen.apply(this, arguments);
  };

  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    var self = this;
    this.addEventListener('load', function() {
      if (
        self._url &&
        (self._url.includes('/cart/add') ||
         self._url.includes('/cart/change') ||
         self._url.includes('/cart/update'))
      ) {
        if (!self._url.includes(String(GIFT_VARIANT_ID))) {
          setTimeout(syncGift, 300);
        }
      }
    });
    return origXHRSend.apply(this, arguments);
  };

  // --- Intercept direct-to-checkout (Buy Now / form submissions) ---
  document.addEventListener('submit', function(e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';

    if (action.includes('/checkout') || action.includes('/cart')) {
      e.preventDefault();
      syncGift(function() {
        form.submit();
      });
    }
  }, true);

  // Intercept clicks on direct checkout links
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/checkout"]');
    if (link) {
      e.preventDefault();
      var href = link.href;
      syncGift(function() {
        window.location.href = href;
      });
    }
  }, true);

  // Run on page load
  syncGift();
})();